import React, { useState, useEffect } from 'react';
import { FiUpload, FiCopy, FiImage } from 'react-icons/fi';
import API from '../utils/api';
import { toast } from 'react-toastify';
import './AdminPages.css';

export default function AdminMedia() {
  const [files, setFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [dragging, setDragging] = useState(false);

  // List uploaded images from /uploads/
  const fetchUploads = async () => {
    try {
      const r = await API.get('/api/admin/settings');
      // Show known images from settings
      const mediaItems = Object.entries(r.data.data || {})
        .filter(([, v]) => v.type === 'image' && v.value)
        .map(([k, v]) => ({ key: k, url: v.value, label: v.label }));
      setFiles(mediaItems);
    } catch (e) {
      console.error(e);
    }
  };
  useEffect(() => { fetchUploads(); }, []);

  const handleUpload = async (file) => {
    if (!file) return;
    const fd = new FormData();
    fd.append('image', file);
    setUploading(true);
    try {
      const r = await API.post('/api/admin/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      toast.success('Image uploaded! URL copied to clipboard.');
      navigator.clipboard?.writeText(r.data.url).catch(() => {});
      // Add to local list
      setFiles(prev => [...prev, { key: `upload_${Date.now()}`, url: r.data.url, label: file.name }]);
    } catch { toast.error('Upload failed'); }
    setUploading(false);
  };

  const handleDrop = (e) => {
    e.preventDefault(); setDragging(false);
    const file = e.dataTransfer.files[0];
    if (file && file.type.startsWith('image/')) handleUpload(file);
  };

  const copyUrl = (url) => {
    navigator.clipboard?.writeText(url);
    toast.success('URL copied to clipboard!');
  };

  // Local images in public/
  const localImgs = [
    { url: '/ladakh.jpg',    label: 'Ladakh — Sangam River' },
    { url: '/kashmir.jpg',   label: 'Kashmir — Green Meadow' },
    { url: '/meghalaya.jpg', label: 'Meghalaya — Dawki River' },
    { url: '/kerala.jpg',    label: 'Kerala — Backwaters' },
    { url: '/srilanka.jpg',  label: 'Sri Lanka — Sigiriya' },
  ];

  return (
    <div>
      <div className="admin-page-header">
        <div><h2>Media Library</h2><p>Upload and manage trip images</p></div>
      </div>

      {/* Upload zone */}
      <div className="admin-card" style={{ marginBottom: 24 }}>
        <div className="admin-card-header"><h3>Upload New Image</h3></div>
        <div className="admin-card-body padded">
          <div
            className="img-upload-box"
            style={{ padding: 40, borderColor: dragging ? 'var(--primary)' : undefined }}
            onDragOver={e => { e.preventDefault(); setDragging(true); }}
            onDragLeave={() => setDragging(false)}
            onDrop={handleDrop}
          >
            <input type="file" accept="image/*" onChange={e => handleUpload(e.target.files[0])} />
            <div className="upload-icon"><FiUpload /></div>
            {uploading
              ? <p>Uploading...</p>
              : <><p><strong>Drag & drop</strong> or click to upload</p><p style={{ fontSize:'0.75rem', marginTop:4 }}>PNG, JPG, WEBP up to 10MB. URL will be auto-copied.</p></>
            }
          </div>
        </div>
      </div>

      {/* Built-in destination images */}
      <div className="admin-card" style={{ marginBottom: 24 }}>
        <div className="admin-card-header"><h3>Destination Photos (Built-in)</h3></div>
        <div className="admin-card-body padded">
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: 14 }}>
            {localImgs.map(img => (
              <div key={img.url} style={{ borderRadius:12, overflow:'hidden', border:'1px solid rgba(0,0,0,0.08)', background:'#fafafa' }}>
                <img src={img.url} alt={img.label} style={{ width:'100%', height:120, objectFit:'cover', display:'block' }}
                  onError={e => { e.target.style.display='none'; }} />
                <div style={{ padding:'10px 12px', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                  <span style={{ fontSize:'0.75rem', color:'var(--text-dark)', fontWeight:500 }}>{img.label}</span>
                  <button className="btn-action view" onClick={() => copyUrl(img.url)} title="Copy URL"><FiCopy /></button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Uploaded images */}
      {files.length > 0 && (
        <div className="admin-card">
          <div className="admin-card-header"><h3>Uploaded Images ({files.length})</h3></div>
          <div className="admin-card-body padded">
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: 14 }}>
              {files.map((f, i) => (
                <div key={i} style={{ borderRadius:12, overflow:'hidden', border:'1px solid rgba(0,0,0,0.08)' }}>
                  <img src={f.url} alt={f.label} style={{ width:'100%', height:120, objectFit:'cover', display:'block' }}
                    onError={e => { e.target.src = '/ladakh.jpg'; }} />
                  <div style={{ padding:'8px 12px', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                    <span style={{ fontSize:'0.72rem', color:'var(--text-light)', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', maxWidth:120 }}>{f.label}</span>
                    <button className="btn-action view" onClick={() => copyUrl(f.url)} title="Copy URL"><FiCopy /></button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {files.length === 0 && localImgs.length === 0 && (
        <div className="admin-empty"><FiImage /><p>No images yet. Upload your first image above.</p></div>
      )}
    </div>
  );
}
